import { render, staticRenderFns } from "./personRuleTab.vue?vue&type=template&id=3c671ccc&scoped=true&"
import script from "./personRuleTab.vue?vue&type=script&lang=js&"
export * from "./personRuleTab.vue?vue&type=script&lang=js&"
import style0 from "./personRuleTab.vue?vue&type=style&index=0&id=3c671ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c671ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c671ccc')) {
      api.createRecord('3c671ccc', component.options)
    } else {
      api.reload('3c671ccc', component.options)
    }
    module.hot.accept("./personRuleTab.vue?vue&type=template&id=3c671ccc&scoped=true&", function () {
      api.rerender('3c671ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/tabPane/personRuleTab.vue"
export default component.exports